
































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, watch, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import HomeworkEditTab from "../../components/HomeworkEditTab.vue";
import DropArea from "../../components/DropArea.vue";

export interface Data {
  tabNo: number
  sheet_group_key: string
  sheet: any,
  imageItems: any[]
  errors: string[]
  currentPage: number
  scale: number
  rotates: number[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "homework-edit-tab": HomeworkEditTab,
    "drop-area": DropArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      tabNo: 2,
      sheet_group_key: null,
      sheet: null,
      imageItems: [],
      errors: [],
      currentPage: 1,
      scale: 0.5,
      rotates: [0, 90, 180, 270],
    });

    /******************************
     * 表示中の画像情報
     ******************************/

    const currentImageItem = computed(() => {
      return state.currentPage > state.imageItems.length ? null : state.imageItems[state.currentPage - 1];
    });

    /******************************
     * ページ数
     ******************************/

    const pageCount = computed((): any => {
      return state.imageItems.length;
    });

    /******************************
     * imgタグのスタイル
     ******************************/

    const imageStyle = computed(() => {
      let style: any = {};
      style["width"] = `${currentImageItem.value.baseWidth * state.scale}px`;
      style["height"] = `${currentImageItem.value.baseHeight * state.scale}px`;
      style["transform"] = `rotate(${currentImageItem.value.angle}deg)`;
      
      // 回転の中心軸設定
      let translateX = "0px";
      let translateY = "0px";
      if(currentImageItem.value.angle == 90){
        translateX = `${currentImageItem.value.baseHeight * state.scale / 2}px`;
        translateY = `${currentImageItem.value.baseHeight * state.scale / 2}px`;
      }else if(currentImageItem.value.angle == 180){
        translateX = `${currentImageItem.value.baseWidth * state.scale / 2}px`;
        translateY = `${currentImageItem.value.baseHeight * state.scale / 2}px`;
      }else if(currentImageItem.value.angle == 270){
        translateX = `${currentImageItem.value.baseWidth * state.scale / 2}px`;
        translateY = `${currentImageItem.value.baseWidth * state.scale / 2}px`;
      }

      style["transform-origin"]  = `${translateX} ${translateY}`;
      return style;
    });

    /******************************
     * imgの親divのスタイル
     ******************************/

    const imageWrapStyle = computed(() => {
      const style: any = {};
      if(currentImageItem.value.angle == 0 || currentImageItem.value.angle == 180){
        style["height"] = `${(currentImageItem.value.baseHeight * state.scale) + 30}px`;
      }else{
        style["height"] = `${(currentImageItem.value.baseWidth * state.scale) + 30}px`;
      }
      return style;
    });

    /******************************
     * 拡大ボタン押下
     ******************************/

    const scaleUp = () => {
      state.scale += 0.05;
    }

    /******************************
     * 縮小ボタン押下
     ******************************/

    const scaleDown = () => {
      if(state.scale > 0.1){
        state.scale -= 0.05;
      }
    }

    /******************************
     * 左回転ボタン押下
     ******************************/
    
    const rotateLeft = async () => {
      var angle = 0;
      var rotateIdx = state.rotates.indexOf(currentImageItem.value.angle);
      if(rotateIdx == 0){
        angle = 270;
      }else{
        angle = currentImageItem.value.angle - 90;
      }
      currentImageItem.value.angle = angle;

      await rotateSave(false, false);
    }

    /******************************
     * 右回転ボタン押下
     ******************************/
    
    const rotateRight = async () => {
      var angle = 0;
      var rotateIdx = state.rotates.indexOf(currentImageItem.value.angle);
      if(rotateIdx == 3){
        angle = 0;
      }else{
        angle = currentImageItem.value.angle + 90;
      }
      currentImageItem.value.angle = angle;

      await rotateSave(false, false);
    }

    /******************************
     * 回転確定ボタン押下
     ******************************/
    
    const rotateSave = async (isConfirmMsg = true, isResutMsg = true) => {
      
      if(currentImageItem.value.angle == 0){
        alert("回転情報は変更されていません。");
        return;
      }
      
      if(isConfirmMsg && !window.confirm(`${state.currentPage}ページ目の回転状態を保存します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/homework_answer_image_upload/rotate/${state.sheet_group_key}`, {angle: currentImageItem.value.angle, page: state.currentPage}).then(response => {
        if (isResutMsg) {
          alert("処理が完了しました。");
        }
        currentImageItem.value.base64Image = response.data.base64_image;
        currentImageItem.value.baseWidth = response.data.image_size_hash.width;
        currentImageItem.value.baseHeight = response.data.image_size_hash.height;
        currentImageItem.value.angle = 0;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * ページ追加
     * 現在のページの次ページに白紙ページを差し込む
     ******************************/

    const addPage = async () => {
      let confirmMsg = "";
      if(state.currentPage == pageCount.value){
        confirmMsg = `末尾に白紙ページを追加します。よろしいですか？`;
      }else{
        confirmMsg = `${state.currentPage}ページ目と${state.currentPage + 1}ページ目の間に白紙ページを追加します。よろしいですか？`;
      }

      if(!window.confirm(confirmMsg)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/homework_answer_image_upload/add_blank_page/${state.sheet_group_key}`, {page: state.currentPage + 1}).then(response => {
        const imageItem = createBlankImageItem();
        state.imageItems.splice(state.currentPage, 0, imageItem);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    const replaceImage = async (files: any) => {

      if(!window.confirm(`${state.currentPage}ページ目の画像を差し替えます。よろしいですか？`)){
        return;
      }

      let fd = new FormData();
      fd.append('upload[file]', files[0]);
      fd.append('page', state.currentPage.toString());

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/homework_answer_image_upload/replace_image/${state.sheet_group_key}`, fd).then(response => {
        // const imageItem = createBlankImageItem();
        // state.imageItems.splice(state.currentPage, 0, imageItem);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * ページ削除
     ******************************/

    const deletePage = async () => {
      if(!window.confirm(`${state.currentPage}ページ目の画像を削除します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/homework_answer_image_upload/delete_page/${state.sheet_group_key}`, {page: state.currentPage}).then(response => {
        state.imageItems.splice(state.currentPage - 1, 1);

        if(state.currentPage > state.imageItems.length){
          state.currentPage--;
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 白紙ページのimageItem生成（A4の縦長）
     ******************************/

    const createBlankImageItem = () => {

      const canvas = document.createElement('canvas') as HTMLCanvasElement;
      canvas.width = 1654;
      canvas.height = 2339; 
      
      const ctx = canvas.getContext('2d');

      // キャンバス全体を白で塗りつぶす
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      const imageItem = {
        base64Image: canvas.toDataURL("image/jpeg").replace("data:image/jpeg;base64,", ""),
        baseWidth: canvas.width,
        baseHeight: canvas.height,
        angle: 0,
      }

      return imageItem;
    }


    const toPositionEdit = () => {
      context.root.$router.push(`/teacher_site/homework_position_edit/${context.root.$route.params.sheet_group_key}`).catch(err => {});
    }

    /******************************
     * 答案アップロード
     ******************************/

    const upload = async (files: any) => {
      const extension = Common.getFileExtension(files[0].name);
      if(extension == "jpg"){
        await uploadJpg(files);
      }else if(extension == "zip"){
        await uploadZip(files);
      }else if(extension == "pdf"){
        await uploadPdf(files);
      }
    }

    /******************************
     * アップロード（Zipドラッグ）
     ******************************/
    
    const uploadZip = async (file: any) => {

      let fd = new FormData();
      fd.append('upload[file]', file[0]);

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/homework_answer_image_upload/upload_zip/${state.sheet_group_key}`, fd).then(response => {

        alert("アップロードが完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * アップロード（jpgドラッグ）
     ******************************/

    const uploadJpg = async (files: any) => {

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const config = {
        headers: {'content-type': 'multipart/form-data'}
      }

      let fd = new FormData();
      fd.append("page_count", files.length.toString());

      for(let i = 0; i < files.length; i++){
        fd.append(`${i}`, files[i]);
      }

      await http.post(`/api/teacher/homework_answer_image_upload/upload_jpg/${state.sheet_group_key}`, fd, config).then((response) => {
        alert("アップロードが完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * アップロード（PDFドラッグ）
     ******************************/
    
    const uploadPdf = async (files: any) => {

      let fd = new FormData();
      fd.append('upload[file]', files[0]);

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/homework_answer_image_upload/upload_pdf/${state.sheet_group_key}`, fd).then(response => {
        alert("アップロードが完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_group_key = context.root.$route.params.sheet_group_key;

      // APIで登録済み試験情報・模範解答画像取得
      await http.get(`/api/teacher/homework_answer_image_upload?sheet_group_key=${state.sheet_group_key}`).then(response => {
        state.sheet = response.data.sheet;
        let imageItems = [];

        if(state.sheet.answer_image_completed){
          for(let i = 0; i < response.data.base64_images.length; i++){
            let imageItem = {
              base64Image: response.data.base64_images[i],
              baseWidth: response.data.image_size_hashes[i].width,
              baseHeight: response.data.image_size_hashes[i].height,
              angle: 0,
            }
            imageItems.push(imageItem);
          }
        }else{
          // const imageItem = createBlankImageItem();
          // imageItems.push(imageItem);
        }

        state.imageItems = imageItems;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goSheetList");
      });

      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      currentImageItem,
      pageCount,
      imageStyle,
      imageWrapStyle,
      scaleUp,
      scaleDown,
      rotateLeft,
      rotateRight,
      addPage,
      deletePage,
      upload,
      replaceImage,
      toPositionEdit,
    }
  }
})
